var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-date-picker',{attrs:{"value":_vm.date,"v-bind":Object.assign({}, _vm.attr),"min":_vm.min,"locale":_vm.$i18n.locale},on:{"input":_vm.close,"change":function($event){return _vm.change($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }